module.exports = __webpack_public_path__ + "img/mtt.fb9191df.png";